import { ExclamationCircleOutlined, MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Affix, Button, Card, Col, Form, Input, InputNumber, message, Modal, Row, Select } from "antd";
import { forwardRef, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  ACCEPTANCE_B2BLC_LIST,
  B2BLC_INVOICE_LIST,
  CHALLAN_LIST,
  FOC_TYPE_INVOICE_LIST,
  SALES_CONTRACT_LIST,
  VEHICLE_INFORMATION,
} from "../../../apiServices/API_ENDPOINTS";
import { getData, postData, putData } from "../../../apiServices/common";
import HandleNotification from "../../../common/Notification";
import { isArrayAndHasValue } from "../../../utils/functions";
import Header from "../../Common/Header";
import ChallanForm from "../../Configuration/ChallanConfig/ChallanForm";

// Constants
const transporter = [
  { id: 1, value: "Self Transport" },
  { id: 2, value: "Raj Transport" },
  { id: 3, value: "SR Enterprise" },
  { id: 4, value: "Vendor" },
];

const importer_names = [
  { id: 1, value: "CONCORDE GARMENTS LTD." },
  { id: 2, value: "OSMAN INTERLININGS LTD." },
  { id: 2, value: "OSMAN ACCESSORIES" },
  { id: 2, value: "OTL-DOUBLE GULL MFG. CO. LTD" },
  { id: 2, value: "LILY APPARELS LTD" },
  { id: 2, value: "SSL WIRELESS" },
  { id: 2, value: "REFLECTIONS" },
  { id: 2, value: "STAINED GLASS OVERLAY" },
  { id: 2, value: "BIDDYUT LTD." },
];

const place_of_loading = [
  { id: 1, value: "CTG" },
  { id: 2, value: "AIRPORT" },
  { id: 3, value: "DEPZ" },
  { id: 4, value: "AEPZ" },
  { id: 5, value: "COMILLA EPZ" },
  { id: 6, value: "BENAPOL" },
  { id: 7, value: "ICD" },
  { id: 8, value: "KAMALAPUR" },
  { id: 9, value: "OTHERS" },
];

const place_of_arrival = [
  { id: 1, value: "MIRPUR" },
  { id: 1, value: "SAVAR EPZ" },
  { id: 1, value: "ASHULIA" },
  { id: 1, value: "ESKATON" },
  { id: 1, value: "KAWRANBAZAR" },
  { id: 1, value: "BARIDHARA" },
  { id: 1, value: "OTHERS" },
];

const ImportVehicleInformationForm = forwardRef((props, ref) => {
  // Props
  const { editMode } = props;

  // States
  const [b2bLcList, setB2bLcList] = useState([]);
  const [poDetailsData, setPoDetailsData] = useState([{ unique_id: 0, vehicle_size: null }]);
  const [challanList, setChallanList] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [salesContractList, setSalesContractList] = useState(null);
  const [updatePerformed, setUpdatePerformed] = useState(false);

  // Router
  const navigate = useNavigate();
  const { importId } = useParams();

  // Antd
  const [form] = Form.useForm();
  const { confirm } = Modal;
  const { Option } = Select;

  const getSelectedVehicleStatus = async (id) => {
    const query = `${VEHICLE_INFORMATION}/${id}`;
    const response = await getData(query);

    if (response && response?.data?.code === 200) {
      const masterData = response?.data?.data;

      form.setFieldsValue({
        loading_place: masterData?.loading_place,
        delivery_place: masterData?.delivery_place,
        transporter: masterData?.transporter,
      });

      const poData =
        isArrayAndHasValue(masterData?.import_vehicle_details) &&
        masterData?.import_vehicle_details?.map((item, index) => {
          const options = item?.type_of_shipment === "FOC" ? item?.foc_invoice_list : item?.b2b_lc_info?.invoice_list;
          const b2bLcFind = b2bLcList.find((b2bLc) => b2bLc.id === item?.b2b_lc_id);

          const salesContract =
            item?.type_of_shipment === "FOC" ? item?.sales_contract_info : b2bLcFind?.sale_contract_info;

          if (!salesContractList?.find((item) => item?.id === salesContract?.id)) {
            // Add the sales contract to the list so it can be displayed
            setSalesContractList((prevList) => {
              const updatedList = prevList || [];
              return [
                ...updatedList,
                {
                  id: salesContract?.id,
                  reference_no: salesContract?.reference_no,
                  sales_contract_number: salesContract?.sales_contract_number,
                },
              ];
            });
          }
          return {
            unique_id: index,
            type_of_shipment: item?.type_of_shipment || null,
            b2b_lc_id: item?.b2b_lc_id || null,
            import_details_id: item?.import_details_id || null,
            sales_contract_id:
              item?.type_of_shipment === "FOC" ? item?.sales_contract_id : b2bLcFind?.sale_contract_info?.id || null,
            invoice_list: options || [],
            vehicle_qty: item?.vehicle_qty || 0,
            vehicle_size: item?.vehicle_size || null,
            quantity_ctn: item?.invoice_info?.quantity_ctn || 0,
            goods_description: item?.invoice_info?.goods_description || "",
            import_quantity_unit: item?.invoice_info?.import_quantity_unit || "",
            buyer_name: item?.invoice_info?.buyer_name || "",
            sales_contract_number: item?.invoice_info?.sales_contract_number || "",
            sales_contract_info:
              item?.type_of_shipment === "FOC" ? item?.sales_contract_id : b2bLcFind?.sale_contract_info || null,
          };
        });

      setPoDetailsData(poData);
    } else {
      HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
    }
  };

  useEffect(() => {
    if (editMode && importId) {
      getSelectedVehicleStatus(importId);
    }
  }, [editMode, importId, b2bLcList]);

  const onChangePoDetailsValue = (value, index, keyName) => {
    // Copy poDetailsData state array
    const poDetailsDataCopy = structuredClone(poDetailsData);
    const foundPoItem = poDetailsDataCopy?.find((item) => item?.unique_id === index);
    foundPoItem[keyName] = value;

    if (keyName === "type_of_shipment") {
      // reset this row all value except type_of_shipment and sales_contract_id
      foundPoItem["b2b_lc_id"] = null;
      foundPoItem["import_details_id"] = null;
      // Keep sales_contract_id so the ID remains visible
      // foundPoItem["sales_contract_id"] = null;
      foundPoItem["invoice_list"] = [];
      foundPoItem["vehicle_qty"] = 0;
      foundPoItem["vehicle_size"] = null;
      foundPoItem["quantity_ctn"] = 0;
      foundPoItem["goods_description"] = "";
      foundPoItem["import_quantity_unit"] = "";
      foundPoItem["buyer_name"] = "";
      // Remove sales_contract_number reset as requested
      // foundPoItem["sales_contract_number"] = "";
    }

    setPoDetailsData(poDetailsDataCopy);
  };

  const getB2BLcList = async () => {
    const query = `${ACCEPTANCE_B2BLC_LIST}`;
    const response = await getData(query);

    if (response && response?.data?.code === 200) {
      setB2bLcList(response?.data?.data || []);
    }
  };

  const getAllChallan = async (filterValues) => {
    const { name } = filterValues || {};
    const query = `${CHALLAN_LIST}`;
    const bodyData = {
      ...(name && { name: name }),
    };

    const response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      setChallanList(response?.data?.data?.data);
    } else {
      message.error("Error getting challan data");
    }
  };

  const getSalesContractList = async (filterValues) => {
    const query = `${SALES_CONTRACT_LIST}`;
    const bodyData = {
      per_page: 10,
      ...(filterValues &&
        filterValues?.name && {
          reference_no: filterValues?.name,
        }),
    };
    let response = await getData(query, false, bodyData);

    if (response && response?.data?.code === 200) {
      const sales_contract_infos = poDetailsData?.map((item) => item?.sales_contract_info);
      console.log("salesContractList", sales_contract_infos);
      setSalesContractList(response?.data?.data?.data);
    } else {
      message.error("Error getting sales contract data");
    }
  };

  // Effects
  useEffect(() => {
    getB2BLcList();
    getAllChallan();
    getSalesContractList();
  }, []);

  useEffect(() => {
    // Early return if conditions not met or update already performed
    if (updatePerformed || !editMode || !importId || !poDetailsData?.length || !salesContractList?.length) {
      return;
    }

    // Get valid sales contract info objects from poDetailsData
    const validContractInfo = poDetailsData
      .filter((item) => item.sales_contract_info && item.sales_contract_info.id)
      .map((item) => item.sales_contract_info);

    // Create a map for quick lookups
    const contractMap = new Map();

    // Add existing sales contracts to the map
    salesContractList.forEach((contract) => {
      if (contract.id) {
        contractMap.set(contract.id, {
          id: contract.id,
          reference_no: contract.reference_no,
          sales_contract_number: contract.sales_contract_number,
        });
      }
    });

    // Add or update contracts from poDetailsData
    validContractInfo.forEach((contract) => {
      if (contract.id && !contractMap.has(contract.id)) {
        contractMap.set(contract.id, {
          id: contract.id,
          reference_no: contract.reference_no,
          sales_contract_number: contract.sales_contract_number,
        });
      }
    });

    // Convert map back to array
    const mergedOptions = Array.from(contractMap.values());

    // Only update state if there are changes
    if (
      mergedOptions.length !== salesContractList.length ||
      JSON.stringify(mergedOptions.map((c) => c.id).sort()) !==
        JSON.stringify(salesContractList.map((c) => c.id).sort())
    ) {
      setSalesContractList(mergedOptions);
    }

    // Mark update as performed
    setUpdatePerformed(true);
  }, [editMode, importId, poDetailsData, salesContractList, updatePerformed]);

  const getInvoiceList = async (lc_id, unique_id) => {
    const getLC = b2bLcList.find((item) => item.id === lc_id);
    const poDetailsDataCopy = structuredClone(poDetailsData);
    const foundPoItem = poDetailsDataCopy?.find((item) => item?.unique_id === unique_id);

    const response = await getData(`${B2BLC_INVOICE_LIST}/${lc_id}`);

    if (response && response?.status === 200) {
      // Set invoice list and b2blc id in po data
      foundPoItem["invoice_list"] = response?.data?.data;
      foundPoItem["b2b_lc_id"] = lc_id;
      if (getLC && foundPoItem["type_of_shipment"] !== "FOC") {
        const salesContract = getLC?.sale_contract_info;
        const foundSalesContractList = salesContractList?.find((item) => item?.id === salesContract?.id);

        if (!foundSalesContractList && salesContract) {
          // Add the sales contract to the list so it can be displayed
          setSalesContractList((prevList) => {
            const updatedList = prevList || [];
            return [
              ...updatedList,
              {
                id: salesContract.id,
                reference_no: salesContract.reference_no,
              },
            ];
          });
        }
        foundPoItem["sales_contract_id"] = salesContract?.id || null;
        foundPoItem["sales_contract_info"] = salesContract || null;
        // reset field
        foundPoItem["import_details_id"] = null;
        foundPoItem["quantity_ctn"] = 0;
        foundPoItem["goods_description"] = "";
        foundPoItem["import_quantity_unit"] = "";
        foundPoItem["buyer_name"] = "";
      }
    } else {
      HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
    }

    setPoDetailsData(poDetailsDataCopy);
  };

  const getFOCInvoiceList = async (value, unique_id) => {
    const poDetailsDataCopy = structuredClone(poDetailsData);
    const foundPoItem = poDetailsDataCopy?.find((item) => item?.unique_id === unique_id);

    const response = await getData(`${FOC_TYPE_INVOICE_LIST}`);

    if (response && response?.data?.code === 200) {
      // Set invoice list and b2blc id in po data
      foundPoItem["type_of_shipment"] = value;
      foundPoItem["invoice_list"] = response?.data?.data;
      foundPoItem["b2b_lc_id"] = null;
      // foundPoItem["import_details_id"] = null;
    } else {
      HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
    }

    setPoDetailsData(poDetailsDataCopy);
  };

  const onSelectInvoice = (id, unique_id, invoiceList) => {
    const foundInvoiceItem = invoiceList.find((item) => item.id === id);

    if (foundInvoiceItem) {
      const poDetailsDataCopy = structuredClone(poDetailsData);
      const foundPoItem = poDetailsDataCopy?.find((item) => item?.unique_id === unique_id);
      foundPoItem["quantity_ctn"] = foundInvoiceItem?.quantity_ctn || 0;
      foundPoItem["goods_description"] = foundInvoiceItem?.goods_description || 0;
      foundPoItem["import_quantity_unit"] = foundInvoiceItem?.import_quantity_unit || 0;
      foundPoItem["buyer_name"] = foundInvoiceItem?.buyer_name || 0;
      foundPoItem["import_details_id"] = id;

      setPoDetailsData(poDetailsDataCopy);
    }
  };

  const removeRow = (row_index) => {
    confirm({
      title: "Do you want to delete this row?",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        const updatedPoDetailsData = poDetailsData.filter((item) => item?.unique_id !== row_index);
        setPoDetailsData(updatedPoDetailsData);
      },
    });
  };

  const addRow = () => {
    const lastItemUniqueId = poDetailsData[poDetailsData.length - 1]?.unique_id;
    const updatedPoDetailsData = [...poDetailsData, { unique_id: lastItemUniqueId + 1, vehicle_size: null }];
    setPoDetailsData(updatedPoDetailsData);
  };

  const onFinishVehicle = async (values) => {
    // console.log("onFinishExportAdd values", values);

    // Validate vehicle size for all rows
    const missingVehicleSize = poDetailsData?.some((obj) => !obj?.vehicle_size);
    if (missingVehicleSize) {
      HandleNotification("error", "bottomRight", "Please select Vehicle Size for all rows", null);
      return;
    }

    const addQuery = `${VEHICLE_INFORMATION}`;
    const editQuery = `${VEHICLE_INFORMATION}/${importId}`;

    const bodyData = {
      transporter: values?.transporter,
      loading_place: values?.loading_place,
      delivery_place: values?.delivery_place,

      lc_invoice_items:
        isArrayAndHasValue(poDetailsData) &&
        poDetailsData?.map((obj, index) => {
          return {
            type_of_shipment: obj?.type_of_shipment || null,
            b2b_lc_id: obj?.b2b_lc_id || null,
            import_details_id: obj?.import_details_id || null,
            sales_contract_id: obj?.sales_contract_id || null,
            vehicle_qty: obj?.vehicle_qty || 0,
            vehicle_size: obj?.vehicle_size?.toString() || null,
          };
        }),
    };

    // console.log({ bodyData });
    // return;

    if (editMode) {
      const response = await putData(editQuery, bodyData);

      if (response && response?.code === 200) {
        HandleNotification("success", "bottomRight", "Successfully Updated!", null);
        navigate("/import/vehicle-information");
      } else {
        HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
      }
    } else {
      const response = await postData(addQuery, bodyData);

      if (response && response?.code === 200) {
        HandleNotification("success", "bottomRight", "Successfully Added!", null);
        navigate("/import/vehicle-information");
      } else {
        HandleNotification("error", "bottomRight", "Something Went Wrong!", null);
      }
    }
  };

  const onModalOpen = () => {
    setIsModalOpen(true);
  };

  const onCloseModal = () => {
    setIsModalOpen(false);
  };

  const discartForm = () => {
    navigate("/import/vehicle-information");
  };

  console.log("poDetailsData", poDetailsData);

  const isAllFOC = poDetailsData?.every((item) => item?.type_of_shipment === "FOC");

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed">
          <Header
            title={`${editMode ? "Update" : "Add"} Vehicle Information`}
            actions={[
              <Affix offsetTop={20}>
                <Button size="small" key={1} danger onClick={() => discartForm()}>
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20}>
                <Button size="small" key={2} type="primary" onClick={() => form.submit()}>
                  Save
                </Button>
              </Affix>,
            ]}
          />
        </Card>
      </Affix>
      <div className="containt-body pt-3">
        <Form layout="vertical" form={form} name="control-hooks" onFinish={onFinishVehicle}>
          <Card>
            <Row gutter={6}>
              <Col span={4}>
                <Form.Item
                  label="Transporter"
                  name="transporter"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Transporter",
                    },
                  ]}
                >
                  <Select placeholder="Transporter" size="small">
                    {transporter.map((option) => {
                      return (
                        <option key={option.id} value={option.value}>
                          {option.value}
                        </option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item
                  label="Place of Loading"
                  name="loading_place"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Place of Loading",
                    },
                  ]}
                >
                  <Select placeholder="Place of Loading" size="small">
                    {place_of_loading.map((option) => {
                      return (
                        <option key={option.id} value={option.value}>
                          {option.value}
                        </option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item
                  label="Place of Arrival"
                  name="delivery_place"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Place of Arrival",
                    },
                  ]}
                >
                  <Select placeholder="Place of Arrival" size="small">
                    {place_of_arrival.map((option) => {
                      return (
                        <option key={option.id} value={option.value}>
                          {option.value}
                        </option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Form>

        <div className="custome-table">
          <table border="1" style={{ marginBottom: "30px" }}>
            <thead>
              <tr>
                <th key="header_shipment_type" className="bc-java ">
                  Type of Shipment
                </th>
                <th key="header_sales_contract" className="bc-java ">
                  Sales Contract
                </th>
                <th key="header_lc_number" className="bc-java ">
                  LC No.
                </th>
                <th key="header_invoice_number" className="bc-java ">
                  Invoice No.
                </th>
                <th key="header_vehicle_qty" className="bc-java ">
                  Vehicle Quantity
                </th>
                <th key="header_vehicle_qty" className="bc-java ">
                  Vehicle Size <span style={{ color: "red" }}>*</span>
                </th>
                <th key="header_goods_description" className="bc-java ">
                  Description of Goods
                </th>
                <th key="header_quantity_ctn" className="bc-java ">
                  Import Quantity
                </th>
                <th key="header_import_quantity_unit" className="bc-java ">
                  Import Quantity Unit
                </th>
                <th key="header_buyer_name" className="bc-java ">
                  Buyer
                </th>

                <th key="header_add_row" className="bc-java ">
                  Add
                </th>
                <th key="header_delete_row" className="bc-java ">
                  Delete
                </th>
              </tr>
            </thead>

            <tbody className="scrollable-table-container">
              {isArrayAndHasValue(poDetailsData) &&
                poDetailsData?.map((obj, index) => {
                  return (
                    <tr key={`table_parent_key_${index}`}>
                      {/* Type of Shipment */}
                      <td className="t-body sticky">
                        <Select
                          placeholder="Type"
                          style={{ width: "100%" }}
                          showSearch
                          size="small"
                          onChange={(value) => onChangePoDetailsValue(value, obj?.unique_id, "type_of_shipment")}
                          onSelect={(value) => {
                            if (value === "FOC") {
                              getFOCInvoiceList(value, obj?.unique_id);
                            }
                          }}
                          value={obj?.type_of_shipment}
                        >
                          <option value="LC">LC</option>
                          <option value="RTGS">RTGS</option>
                          <option value="FOC">FOC</option>
                          <option value="TT">TT</option>
                        </Select>
                      </td>
                      {/* Sales contract */}
                      <td className="t-body sticky">
                        <Select
                          placeholder="Sales Contract"
                          style={{ width: "100%" }}
                          showSearch
                          size="small"
                          onChange={(value) => onChangePoDetailsValue(value, obj?.unique_id, "sales_contract_id")}
                          onSearch={(value) => getSalesContractList({ name: value })}
                          filterOption={false}
                          value={obj?.sales_contract_id}
                          disabled={obj?.type_of_shipment !== "FOC"}
                        >
                          {isArrayAndHasValue(salesContractList) &&
                            salesContractList.map((option) => {
                              return (
                                <option key={option.id} value={option.id}>
                                  {option.reference_no}
                                </option>
                              );
                            })}
                        </Select>
                      </td>
                      {/* LC Number */}
                      <td className="t-body sticky">
                        <Select
                          placeholder="LC Number"
                          style={{ width: "100%" }}
                          showSearch
                          filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                          size="small"
                          onSelect={(value) => getInvoiceList(value, obj?.unique_id)}
                          value={obj?.b2b_lc_id}
                          disabled={obj?.type_of_shipment === "FOC"}
                        >
                          {b2bLcList.map((option) => {
                            return (
                              <option key={option.id} value={option.id}>
                                {option.b2b_lc_number}
                              </option>
                            );
                          })}
                        </Select>
                      </td>
                      {/* Invoice Number */}
                      <td className="t-body sticky">
                        <Select
                          placeholder="Invoice No."
                          style={{ width: "100%" }}
                          showSearch
                          filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                          size="small"
                          onSelect={(value) => onSelectInvoice(value, obj?.unique_id, obj?.invoice_list)}
                          disabled={!isArrayAndHasValue(obj?.invoice_list)}
                          value={obj?.import_details_id}
                        >
                          {isArrayAndHasValue(obj?.invoice_list) &&
                            obj?.invoice_list?.map((option) => {
                              return (
                                <option key={option.id} value={option.id}>
                                  {option.invoice_number}
                                </option>
                              );
                            })}
                        </Select>
                      </td>

                      {/* Vehicle Quantity */}
                      <td className="t-body sticky">
                        <InputNumber
                          value={obj?.vehicle_qty || 0}
                          placeholder="Vehicle Qty."
                          size="small"
                          min={0}
                          onChange={(value) => onChangePoDetailsValue(value, obj?.unique_id, "vehicle_qty")}
                        />
                      </td>
                      {/* Vehicle Size */}
                      <td className="t-body sticky">
                        <Select
                          placeholder="Vehicle Size"
                          style={{ width: "100%" }}
                          size="small"
                          onChange={(value) => onChangePoDetailsValue(value, obj?.unique_id, "vehicle_size")}
                          value={obj?.vehicle_size}
                          status={!obj?.vehicle_size ? "error" : ""}
                        >
                          <Option value={10}>10</Option>
                          <Option value={12}>12</Option>
                          <Option value={14}>14</Option>
                          <Option value={15}>15</Option>
                          <Option value={16}>16</Option>
                          <Option value={18}>18</Option>
                          <Option value={20}>20</Option>
                          <Option value={23}>23</Option>
                        </Select>
                      </td>
                      {/* Description of Goods */}
                      <td className="t-body sticky">
                        <Input
                          value={obj?.goods_description}
                          placeholder="Description of Goods"
                          size="small"
                          disabled
                        />
                      </td>
                      {/* Import Qty. */}
                      <td className="t-body sticky">
                        <Input value={obj?.quantity_ctn} placeholder="Import Qty." size="small" disabled />
                      </td>
                      {/* Import Qty. Unit */}
                      <td className="t-body sticky">
                        <Input value={obj?.import_quantity_unit} placeholder="Import Qty. Unit" size="small" disabled />
                      </td>
                      {/* Buyer */}
                      <td className="t-body sticky">
                        <Input value={obj?.buyer_name} placeholder="Buyer" size="small" disabled />
                      </td>

                      <td className="t-body" onClick={addRow}>
                        <PlusCircleOutlined className="cursore-pointer" style={{ fontSize: "16px", color: "Green" }} />
                      </td>
                      <td
                        className="t-body"
                        onClick={() => {
                          removeRow(obj?.unique_id);
                        }}
                      >
                        <MinusCircleOutlined className="cursore-pointer" style={{ fontSize: "16px", color: "red" }} />
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <Modal
          open={isModalOpen}
          title={"Create Challan"}
          onCancel={() => {
            onCloseModal();
          }}
          maskStyle={{ backdropFilter: "blur(4px)" }}
          footer={null}
        >
          <ChallanForm
            isEdit={false}
            onCloseModal={onCloseModal}
            from={"inventory"}
            refetch={getAllChallan}
            isVehicleStatus={true}
          />
        </Modal>
      </div>
    </>
  );
});

export default ImportVehicleInformationForm;
